import { render } from "./VPage.vue?vue&type=template&id=637ad14e&scoped=true"
import script from "./VPage.vue?vue&type=script&lang=js"
export * from "./VPage.vue?vue&type=script&lang=js"

import "./VPage.vue?vue&type=style&index=0&id=637ad14e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637ad14e"]])

export default __exports__